import React from 'react';
import { Link } from 'react-router-dom';
import './ActionButton.css';

const icon = (
  <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.82352 16.1369L16.8223 5.13818'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.8613 16.0786L17.1353 4.82281L5.19917 5.11336'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ActionButton = ({
  to,
  href,
  url,
  text = 'Learn more',
  className = '',
  onClick,
  disabled = false,
  target,
  fullWidth = false,
  size,
  clickTrackValue,
}) => {
  const wrapperClassName = [
    'action-btn-wrapper',
    className,
    fullWidth && 'action-btn-wrapper--full',
    size && `action-btn-wrapper--${size}`,
    clickTrackValue && 'custom_click_track',
    disabled && 'disabled',
  ]
    .filter(Boolean)
    .join(' ');

  const trackingProps = clickTrackValue
    ? { 'data-custom_click_track_value': clickTrackValue }
    : {};

  const opensNewTab = target === '_blank';

  const children = (
    <>
      <span className='action-btn'>
        {text}
        {opensNewTab && <span className='sr-only'> (opens in a new tab)</span>}
      </span>
      <span className='action-btn-icon'>{icon}</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={wrapperClassName} {...trackingProps}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noreferrer' : undefined}
        className={wrapperClassName}
        {...trackingProps}
      >
        {children}
      </a>
    );
  }

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onClick) {
      onClick(e);
    } else if (url) {
      window.location.href = url;
    }
  };

  return (
    <button
      type='button'
      className={wrapperClassName}
      onClick={handleClick}
      disabled={disabled}
      aria-disabled={disabled}
      {...trackingProps}
    >
      {children}
    </button>
  );
};

export default ActionButton;
